import Loadable from '../../components/loadable';

const ContactDashlets = Loadable({
  loader: () => import('../../pages/contacts/dashlets'),
  type: 'block',
});

angular.module('gym').value('ContactDashlets', ContactDashlets);
